"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifyAisleCode = void 0;
const modifyAisleCode = (aisleCode) => {
    const match = aisleCode.match(/0-A(\d+)/);
    if (match) {
        const originNumber = parseInt(match[1], 10);
        const newNumber = originNumber + 1;
        return newNumber.toString();
    }
    else {
        return 'Formato no válido';
    }
};
exports.modifyAisleCode = modifyAisleCode;
